import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const KEY = "jp_cookie_consent_v1";

export default function CookieBanner() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    try {
      const stored = window.localStorage.getItem(KEY);
      if (!stored) setOpen(true);
    } catch {
      /* private browsing — show banner */
      setOpen(true);
    }
  }, []);

  // Hide on dashboard (admin) — banner is only for public visitors
  if (!open || location.pathname.startsWith("/dashboard")) return null;

  const decide = (value) => {
    try {
      window.localStorage.setItem(
        KEY,
        JSON.stringify({ value, at: new Date().toISOString() }),
      );
      if (window.posthog) {
        if (value === "accept") window.posthog.opt_in_capturing();
        else window.posthog.opt_out_capturing();
      }
    } catch {/* ignore */}
    setOpen(false);
  };

  return (
    <div
      data-testid="cookie-banner"
      role="region"
      aria-label="Cookie notice"
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 md:max-w-md z-[100]"
    >
      <div className="bg-navy text-cream border-l-2 border-gold shadow-xl p-5">
        <div className="overline text-gold mb-2">Cookies</div>
        <p className="text-sm text-cream/85 leading-relaxed font-light">
          This site uses essential cookies for authentication and anonymous analytics to improve the experience.
          No tracking cookies set without your consent.{" "}
          <Link to="/privacy" data-testid="cookie-privacy-link" className="text-gold hover:underline">
            Learn more
          </Link>.
        </p>
        <div className="mt-4 flex flex-wrap gap-2 justify-end">
          <button
            onClick={() => decide("decline")}
            data-testid="cookie-decline"
            className="text-xs uppercase tracking-widest text-cream/70 hover:text-gold px-3 py-2"
          >
            Decline
          </button>
          <button
            onClick={() => decide("accept")}
            data-testid="cookie-accept"
            className="text-xs uppercase tracking-widest bg-gold text-navy px-4 py-2 hover:bg-gold-soft"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
